
export enum PieceTypes {
	O, 
	T, T90, T180, T270, 
	S, S90, 
	Z, Z90,
	J, J90, J180, J270,
	L, L90, L180, L270,
	I, I90
}